import { useQuery } from '@tanstack/react-query';

import { getEnvironment, getEnvironments } from '@/api/apiEnvironments';

export function useEnvironments() {
  return useQuery({
    queryKey: ['environments', 'list'],
    queryFn: getEnvironments,
  });
}

export function useEnvironment(environmentId?: number) {
  return useQuery({
    queryKey: ['environments', 'detail', environmentId],
    queryFn: () => getEnvironment(environmentId as number),
    enabled: environmentId !== undefined,
  });
}